import {
  IErrors,
  IShowErrors,
  IValues,
} from '../../types/interface/Contrats/contratRattacher';

export const initValues: IValues = {
  dateDebut: '',
  duration: '',
  amount: '',
  acceptTerm: false,
  vehiculeImageAvant: [],
  vehiculeImageArriere: [],
  vehiculeImageDroite: [],
  vehiculeImageGauche: [],
  vehiculeBatterieImage: [],
  garanties: [],
};

export const initErrors: IErrors = {
  dateDebut: '',
  duration: '',
  amount: '',
};

export const initHideErrors: IShowErrors = {
  dateDebut: false,
  duration: false,
  amount: false,
  vehiculeImageAvant: false,
  vehiculeImageArriere: false,
  vehiculeImageDroite: false,
  vehiculeImageGauche: false,
  vehiculeBatterieImage: false,
  acceptTerm: false,
};
export const initShowErrors: IShowErrors = {
  dateDebut: true,
  duration: true,
  amount: true,
  vehiculeImageAvant: true,
  vehiculeImageArriere: true,
  vehiculeImageDroite: true,
  vehiculeImageGauche: true,
  vehiculeBatterieImage: true,
  acceptTerm: true,
};

export const listDuree: {label: string; value: string}[] = [
  {
    label: 'selectionner une durée',
    value: '',
  },
  {
    label: '1 mois',
    value: '1',
  },
  {
    label: '3 mois',
    value: '3',
  },
  {
    label: '6 mois',
    value: '6',
  },
  {
    label: '9 mois',
    value: '9',
  },
  {
    label: '12 mois',
    value: '12',
  },
];

export const autoPhotoLabels = [
  {
    label: 'Photo avant',
    name: 'vehiculeImageAvant',
  },
  {
    label: 'Photo arrière',
    name: 'vehiculeImageArriere',
  },
  {
    label: 'Photo profil droit',
    name: 'vehiculeImageDroite',
  },
  {
    label: 'Photo profil gauche',
    name: 'vehiculeImageGauche',
  },
  {
    label: 'Photo batterie',
    name: 'vehiculeBatterieImage',
  },
];
